// extracted by mini-css-extract-plugin
export default {"pendingSkeleton":"Lessons_pendingSkeleton__y5BuH"};